export default "__VITE_ASSET__BbFMhMpw__"